import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56b9ef88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "document bg-white relative overflow-y-scroll" }
const _hoisted_2 = { class: "body" }
const _hoisted_3 = { class: "title-section-spacing sticky top-0 bg-white z-20" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-left text-primary-600 font-bold" }, "Indietro", -1))
const _hoisted_5 = { class: "title-row pt-6 pb-6" }
const _hoisted_6 = { class: "font-bold block text-left pb-4" }
const _hoisted_7 = { class: "buttons items-center flex" }
const _hoisted_8 = { class: "font-bold text-left subtitle" }
const _hoisted_9 = {
  key: 0,
  class: "buttons-section flex"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "searchbar flex" }
const _hoisted_12 = { class: "users-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeftArrow = _resolveComponent("LeftArrow")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DocumentCard = _resolveComponent("DocumentCard")!
  const _component_AddEditDocumentModalDialog = _resolveComponent("AddEditDocumentModalDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "header w-full fixed relative inline-flex cursor-pointer",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
        }, [
          _createVNode(_component_LeftArrow, { class: "back-arrow" }),
          _hoisted_4
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.isDocumentsToBeApproved ? 'Gestione documenti da approvare' : 'Gestione documenti'), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.isDocumentsToBeApproved ? 'Tutti i documenti da approvare' : 'Tutti i documenti caricati'), 1),
          (!_ctx.isDocumentsToBeApproved)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_router_link, {
                  class: "block focus:outline-none focus:shadow-outline",
                  type: "button",
                  to: `/working-sites/${_ctx.workingSiteId}/tags`
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_PrimaryButton, { class: "text-primary-600 button" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Gestisci Tag")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["to"]),
                _createVNode(_component_PrimaryButton, {
                  class: "working-site-button-highlighted text-primary-600",
                  onClick: _ctx.onUnapprovedDocuments
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Da approvare"),
                    (_ctx.unapprovedDocuments != undefined)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, " (" + _toDisplayString(_ctx.unapprovedDocuments) + ")", 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_PrimaryButton, {
                  class: "bg-primary-600 text-white button",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShowingAddNewDocument = true))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Nuovo")
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("input", {
            class: "text px-4 py-3 flex-grow",
            type: "text",
            placeholder: "Cerca documento",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchQuery) = $event)),
            onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.search()), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.searchQuery]
          ]),
          _createVNode(_component_PrimaryButton, {
            class: "button bg-white text-primary flex-none",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.search()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cerca")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documents, (doc) => {
            return (_openBlock(), _createBlock(_component_DocumentCard, {
              key: doc.id,
              "model-value": doc,
              scope: _ctx.DocumentScope.workingSiteDocument,
              "working-site-id": _ctx.workingSiteId,
              tags: _ctx.tags,
              "is-document-to-be-approved": _ctx.isDocumentsToBeApproved
            }, null, 8, ["model-value", "scope", "working-site-id", "tags", "is-document-to-be-approved"]))
          }), 128))
        ])
      ])
    ]),
    (_ctx.isShowingAddNewDocument)
      ? (_openBlock(), _createBlock(_component_AddEditDocumentModalDialog, {
          key: 0,
          onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isShowingAddNewDocument = false)),
          tags: _ctx.tags,
          scope: _ctx.DocumentScope.workingSiteDocument,
          "working-site-id": _ctx.workingSiteId
        }, null, 8, ["tags", "scope", "working-site-id"]))
      : _createCommentVNode("", true)
  ]))
}